import React, { useEffect, useState } from 'react';
import '../../styles/dashboard.css';
import useAxiosPrivate from '../../api/useAxiosPrivate';
import { notify } from '../toast';
import { Stat } from './IncentivePanel';

const EmployeePayouts = ({ role }) => {
    const axiosPrivate = useAxiosPrivate();
    const [salary, setSalary] = useState({});

    useEffect(() => {
        const fetch = async () => {
            try {
                const res = await axiosPrivate.get('/payout/myPayouts');
                const records = res.data;
                const pay = records?.reduce((Tp, p) => {
                    Tp['totalAmount'] = (Tp['totalAmount'] || 0) + p['totalAmount'];
                    Tp['directCards'] = (Tp['directCards'] || 0) + p['directCards'];
                    Tp['directRegistrationIncentive'] = (Tp['directRegistrationIncentive'] || 0) + p['directRegistrationIncentive'];
                    Tp['referralCards'] = (Tp['referralCards'] || 0) + p['referralCards'];
                    Tp['referralIncentive'] = (Tp['referralIncentive'] || 0) + p['referralIncentive'];

                    return Tp;
                }, {})

                setSalary(pay);
            } catch (err) {
                notify('failed', err?.response?.data?.message);
            }
        };
        fetch();
        // eslint-disable-next-line
    }, []);

    const fmt = (n) => `₹${Number(n || 0).toLocaleString('en-IN')}`;

    if (!salary) return <div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>No payout salary yet.</div>;

    return (
        <div className="container">
            <h2 style={{ textAlign: 'center', margin: '20px 0', color: 'var(--secondary-text-color)' }}>
                My Salary Payouts
            </h2>

            <div style={styles.monthCard}>
                <div style={styles.periodRow}>
                    <div style={styles.totalBox}>
                        <span style={styles.totalLabel}>Total</span>
                        <span style={styles.totalValue}>{fmt(salary.totalAmount)}</span>
                    </div>
                </div>

                <div style={styles.periodRow}>
                    {role !== 'village_cluster' ?
                        <>
                            <Stat label="Direct Cards" value={salary.directCards} />
                            <Stat label="Direct Incentive" value={fmt(salary.directRegistrationIncentive)} />
                        </>
                        :
                        <>
                            <Stat label="Cards" value={salary.directCards} />
                            <Stat label="Incentive" value={fmt(salary.directRegistrationIncentive)} />
                        </>
                    }

                    {role !== 'village_cluster' ?
                        <>
                            <Stat label="Referral Cards" value={salary.referralCards} />
                            <Stat label="Referral Incentive" value={fmt(salary.referralIncentive)} />
                        </>
                        : <></>
                    }

                    <Stat label="Base Salary" value={fmt(salary.baseSalary)} />
                </div>
            </div>
        </div>
    );
};

const styles = {
    monthCard: {
        background: '#fff',
        border: '1px solid var(--text-accent-color)',
        borderRadius: 12,
        marginBottom: 14,
        overflow: 'hidden',
        width: '70%',
        margin: '0 auto 14px',
    },
    periodRow: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 12,
        alignItems: 'center',
        padding: '12px 18px',
    },
    totalBox: {
        textAlign: 'left',
        minWidth: 80
    },
    totalLabel: {
        fontSize: '.72rem',
        color: '#aaa',
        display: 'block',
    },
    totalValue: {
        fontSize: '1rem',
        fontWeight: 700,
        color: 'var(--secondary-text-color)',
    },
};

export default EmployeePayouts;
